import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Footer from "components/Footer/Footer.jsx";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.jsx";

const FooterSection = props => {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div>
        <Footer
          theme="dark"
          content={
            <div>
              <div className={classes.left}>
                <a href="." className={classes.footerBrand}>
                  TEN
                </a>
              </div>
              <div className={classes.pullCenter}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://www.navitas.com/privacy_policy"
                      className={classes.block}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy & Security
                    </a>
                  </ListItem>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href={"mailto:learning.ten@navitas.com"}
                      className={classes.block}
                    >
                      Contact
                    </a>
                  </ListItem>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://www.navitas.com/"
                      className={classes.block}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      About Navitas
                    </a>
                  </ListItem>
                </List>
              </div>
              <div className={classes.rightLinks}>
                <ul>
                  <li>
                    <Button
                      href="https://twitter.com/Navitas_LandT"
                      color="white"
                      target="_blank"
                      justIcon
                      simple
                    >
                      <i className="fab fa-twitter" />
                    </Button>
                  </li>
                  <li>
                    <Button
                      href="https://www.linkedin.com/showcase/learning-and-teaching-navitas/"
                      color="white"
                      target="_blank"
                      justIcon
                      simple
                    >
                      <i className="fab fa-linkedin" />
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(FooterSection);
